export enum EIcons {
	accesories = 'accesorios.svg',
	accountCircle = 'account_circle',
	add = 'add',
	adminPanelSettings = 'admin_panel_settings',
	apps = 'apps',
	arrowBack = 'arrow_back',
	arrowForward = 'arrow_forward',
	calendarMonth = 'calendar_month',
	circleCheckSolid = 'circle-check-solid.svg',
	circleExclamationSolid = 'circle-exclamation-solid.svg',
	circleInfoSolid = 'circle-info-solid.svg',
	circleXmarkSolid = 'circle-xmark-solid.svg',
	circleUserSolid = 'circle-user-solid.svg',
	chevronLeftSolid = 'chevron-left-solid.svg',
	chevronRightSolid = 'chevron-right-solid.svg',
	cleaning_services = 'cleaning_services',
	configuraciones = 'configuraciones.svg',
	delete = 'delete',
	diamante = 'diamante.svg',
	directionsCar = 'directions_car',
	documents = 'documentos.svg',
	download = 'download',
	dragIndicator = 'drag_indicator',
	drivers = 'drivers.svg',
	edit = 'edit',
	ellipsisVerticalSolid = 'ellipsis-vertical-solid.svg',
	expandMore = 'expand-more.svg',
	eye = 'eye.svg',
	fleet = 'fleet-board.svg',
	gripVerticalSolid = 'grip-vertical-solid.svg',
	history = 'history.svg',
	incidents = 'siniestros.svg',
	insertChart = 'insert_chart',
	locations = 'lugares.svg',
	logout = 'logout',
	map = 'map',
	menu = 'menu',
	menuOpen = 'menu_open',
	moreVert = 'more_vert',
	multas = 'multas.svg',
	multas_list = 'multas-list.svg',
	penToSquareSolid = 'pen-to-square-solid.svg',
	photo_camera = 'photo_camera',
	planning = 'planning.svg',
	preventiveServices = 'servicios-preventivos.svg',
	publish = 'publish',
	queryStats = 'query_stats',
	rebalances = 'rebalanceos.svg',
	refresh = 'refresh',
	rightFromBracketSolid = 'right-from-bracket-solid.svg',
	schedule = 'schedule',
	servicesAndRepairs = 'servicios-reparaciones.svg',
	settings = 'settings',
	skipNext = 'skip_next',
	skipPrevious = 'skip_previous',
	squareCaretLeftSolid = 'square-caret-left-solid.svg',
	squareCaretRightSolid = 'square-caret-right-solid.svg',
	states = 'estados.svg',
	trashSolid = 'trash-solid.svg',
	tune = 'tune',
	upload_file = 'upload_file',
	vehicles = 'vehiculos.svg',
	viewTimeline = 'view_timeline',
	xmarkSolid = 'xmark-solid.svg',
	vehicleOperation = 'vehiculos-operation.svg',
}

export enum EIconSpace {
	left = 'left',
	right = 'right',
	none = 'none',
}

export enum EIconType {
	normal = 'normal',
	svg = 'svg',
}

export enum EIconSize {
	extraLarge = 'extraLarge',
	large = 'large',
	medium = 'medium',
	normal = 'normal',
	small = 'small',
	tiny = 'tiny',
}

export enum EIconButtonSize {
	large = 'large',
	medium = 'medium',
	normal = 'normal',
	small = 'small',
	tiny = 'tiny',
}
